<script lang="ts">
  import { page } from '$app/state';
  import FooterComponent from '$components/contentful/standard/FooterComponent/FooterComponent.svelte';
  import PublicWebNav from '$lib/components/PublicWebNav/PublicWebNav.svelte';
</script>

{#if page.error?.navProps}
  <svelte:boundary onerror={console.error}><PublicWebNav {...page.error.navProps} /></svelte:boundary>
{/if}

<section class="HeroSection">
  <div class="content">
    <div class="contentWrapper">
      {#if page.error?.heading}
        <div class="font-eyebrow-large">
          {page.error.heading}
        </div>
      {/if}
      {#if page.error?.body}
        <h1 class="balance-text">
          {page.error.body}
        </h1>
      {/if}
      {#if page.error?.message}
        <p>
          {page.error.message}
        </p>
      {/if}
    </div>
  </div>
</section>

{#if page.error?.footerProps}
  <svelte:boundary onerror={console.error}><FooterComponent {...page.error.footerProps} /></svelte:boundary>
{/if}

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/core/config/typography' as typography;
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/variables' as vars;

  .HeroSection {
    text-align: center;
    background-color: var(--color-white);
    position: relative;

    .content {
      max-width: 100%;
      padding: var(--space-80) 0;
      z-index: 3;
      position: relative;
    }

    .contentWrapper {
      max-width: 100%;
      margin: auto;

      :global(p) {
        // retain 40em width on p per hotfix - WEBENG-3820
        max-width: 40em;
        margin-left: inherit;
        margin-right: inherit;
      }
    }

    h1 {
      margin-top: 0;

      &:not(:last-child) {
        margin-bottom: var(--space-20);
      }
    }

    .font-eyebrow-large {
      @include typography.eyebrow;
    }

    @media (min-width: vars.$breakpoint-width-medium) {
      .content {
        padding: var(--space-120) 0;
      }
    }
  }
</style>
